import { __extends, __spread, __read } from 'tslib';
import { Component, Input, Injectable, ViewEncapsulation, EventEmitter, Output, ViewChild, ChangeDetectorRef, Pipe, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormGroup, Validators, FormControl, FormArray, NG_VALUE_ACCESSOR, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { cloneDeep, merge, pickBy, identity, isEqual } from 'lodash';
import 'reflect-metadata';
import { SelectionType, ColumnMode, NgxDatatableModule } from '@swimlane/ngx-datatable';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import * as moment_ from 'moment';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/shareReplay';
import { createStore, combineReducers, applyMiddleware } from 'redux';
import { createEpicMiddleware, combineEpics } from 'redux-observable';
import { composeWithDevTools } from 'redux-devtools-extension';
import { Observable as Observable$1 } from 'rxjs';
import { CommonModule } from '@angular/common';
import { NgxMyDatePickerModule } from 'ngx-mydatepicker';
import { ColorPickerModule } from 'ngx-color-picker';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';

var BaseModel = /** @class */ (function () {
    function BaseModel() {
    }
    BaseModel.prototype.getFormOptions = function (mode) {
        throw Error('error: missing @Form() decorator on model ' + this.constructor.name);
    };
    BaseModel.prototype.getEntry = function (mode, key) {
        throw Error('error: missing @Form() decorator on model ' + this.constructor.name);
    };
    BaseModel.prototype.getEntries = function (mode) {
        throw Error('error: missing @Form() decorator on model ' + this.constructor.name);
    };
    BaseModel.prototype.getProperties = function (mode) {
        throw Error('error: missing @Form() decorator on model ' + this.constructor.name);
    };
    BaseModel.prototype.getLayout = function (mode) {
        throw Error('error: missing @Form() decorator on model ' + this.constructor.name);
    };
    BaseModel.prototype.getPropertiesByLayout = function (mode, layout) {
        throw Error('error: missing @Form() decorator on model ' + this.constructor.name);
    };
    BaseModel.prototype.registerFormOnChanges = function (modes, onChanges) {
        throw Error('error: missing @Form() decorator on model ' + this.constructor.name);
    };
    BaseModel.prototype.registerEntryDynamicProperty = function (modes, propertyName, entryOptionName, entryOptionValue) {
        throw Error('error: missing @Form() decorator on model ' + this.constructor.name);
    };
    BaseModel.prototype.registerEntriesDynamicProperty = function (modes, propertyName, entryOptions) {
        throw Error('error: missing @Form() decorator on model ' + this.constructor.name);
    };
    BaseModel.prototype.registerEntriesDynamicProperties = function (modes, entries) {
        throw Error('error: missing @Form() decorator on model ' + this.constructor.name);
    };
    BaseModel.prototype.getResource = function (mode, method) {
        throw Error('error: missing @Resource() decorator on model ' + this.constructor.name);
    };
    BaseModel.prototype.getCache = function (mode, method) {
        throw Error('error: missing @Resource() decorator on model ' + this.constructor.name);
    };
    BaseModel.prototype.invalidateCache = function (mode, method) {
        throw Error('error: missing @Resource() decorator on model ' + this.constructor.name);
    };
    return BaseModel;
}());
var AutoFormComponent = /** @class */ (function () {
    function AutoFormComponent() {
    }
    AutoFormComponent.prototype.ngOnInit = function () {
    };
    return AutoFormComponent;
}());
AutoFormComponent.decorators = [
    { type: Component, args: [{
                selector: 'auto-form',
                template: "\n<div *ngIf=\"model && form && mode\" class=\"row\">\n    <div *ngFor=\"let layoutColumn of model.getLayout(mode).columns\"\n        [class]=\"layoutColumn.cssClass\">\n        <div class=\"row\">\n            <div *ngFor=\"let property of model.getPropertiesByLayout(mode, layoutColumn.name)\"\n                [class]=\"model.getEntry(mode, property).css.group\">\n\n                <form-input\n                    *ngIf=\"!(model.getEntry(mode, property).nested)\"\n                    [model]=\"model\"\n                    [form]=\"form\"\n                    [mode]=\"mode\"\n                    [propertyName]=\"property\">\n                </form-input>\n\n                <span *ngIf=\"model.getEntry(mode, property).nested && !model.getEntry(mode, property).hidden\">\n\n                    <span *ngIf=\"model.getEntry(mode, property).multiple\">\n                        <auto-form\n                            *ngFor=\"let item of model[property]; let i = index\"\n                            [model]=\"item\"\n                            [mode]=\"mode\"\n                            [form]=\"form.controls[property].controls[i]\">\n                        </auto-form>\n                    </span>\n\n                    <span *ngIf=\"!model.getEntry(mode, property).multiple\">\n                        <auto-form\n                            [model]=\"model[property]\"\n                            [mode]=\"mode\"\n                            [form]=\"form.controls[property]\">\n                        </auto-form>\n                    </span>\n                </span>\n\n            </div>\n        </div>\n    </div>\n</div>\n",
            },] },
];
AutoFormComponent.ctorParameters = function () { return []; };
AutoFormComponent.propDecorators = {
    "model": [{ type: Input },],
    "form": [{ type: Input },],
    "mode": [{ type: Input },],
};
var EntryTypes = {
    STATIC: 'static',
    TEXT: 'text',
    DATE: 'date',
    NUMBER: 'number',
    SELECT: 'select',
    RADIO: 'radio',
    CHECKBOX: 'checkbox',
    TABLE: 'table',
    CARDS: 'cards',
    TEXTAREA: 'textarea',
    COLOR: 'color',
    TIME: 'time',
    TEL: 'tel',
};
var Option = /** @class */ (function () {
    function Option() {
    }
    return Option;
}());
var EntryParams = /** @class */ (function () {
    function EntryParams() {
    }
    return EntryParams;
}());
var EntryOptions = /** @class */ (function () {
    function EntryOptions() {
    }
    return EntryOptions;
}());
var BasicEntryOptions = /** @class */ (function (_super) {
    __extends(BasicEntryOptions, _super);
    function BasicEntryOptions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return BasicEntryOptions;
}(EntryOptions));
var DateEntryOptions = /** @class */ (function (_super) {
    __extends(DateEntryOptions, _super);
    function DateEntryOptions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return DateEntryOptions;
}(EntryOptions));
var ChoicesEntryOptions = /** @class */ (function (_super) {
    __extends(ChoicesEntryOptions, _super);
    function ChoicesEntryOptions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ChoicesEntryOptions;
}(EntryOptions));
var CollectionEntry = /** @class */ (function (_super) {
    __extends(CollectionEntry, _super);
    function CollectionEntry() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CollectionEntry;
}(EntryOptions));
var CardEntryOptions = /** @class */ (function (_super) {
    __extends(CardEntryOptions, _super);
    function CardEntryOptions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CardEntryOptions;
}(CollectionEntry));
var TableEntryOptions = /** @class */ (function (_super) {
    __extends(TableEntryOptions, _super);
    function TableEntryOptions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TableEntryOptions;
}(CollectionEntry));
function Entry(entryParams) {
    return function (target, key) {
        Object.keys(entryParams)
            .filter(function (mode) { return mode !== 'base'; })
            .forEach(function (mode) {
            if (entryParams.base) {
                entryParams[mode] = merge({}, entryParams.base, entryParams[mode]);
            }
            entryParams[mode].propertyName = key;
            if (!entryParams[mode].layout) {
                entryParams[mode].layout = 'center';
            }
            if (!entryParams[mode].css) {
                entryParams[mode].css = {
                    box: '',
                    label: '',
                    input: '',
                    group: '',
                };
            }
        });
        Reflect.defineMetadata("__entry__", Object.assign({}, entryParams), target, key);
        var properties = Reflect.getOwnMetadata("__properties__", target) || [];
        properties.push(key);
        Reflect.defineMetadata('__properties__', properties, target);
    };
}
var FormGeneratorService = /** @class */ (function () {
    function FormGeneratorService() {
    }
    FormGeneratorService.prototype.toEmptyObject = function (model) {
        var obj = cloneDeep(model);
        for (var key in obj) {
            if (obj.hasOwnProperty(key)) {
                obj[key] = null;
            }
        }
        return obj;
    };
    FormGeneratorService.prototype.createFormGroup = function (model, mode, data) {
        var _this = this;
        if (data === void 0) { data = {}; }
        var group = {};
        if (model instanceof Array) {
            group = new FormArray([]);
            if (model.length) {
                model.forEach(function (item) {
                    group.push(_this.toFormGroup(item, mode, data));
                });
            }
        }
        else {
            group = this.toFormGroup(model, mode, data);
        }
        return group;
    };
    FormGeneratorService.prototype.toFormGroup = function (model, mode, data) {
        var _this = this;
        if (data === void 0) { data = {}; }
        var group = {};
        if (!model)
            return new FormGroup({});
        model.getProperties(mode).forEach(function (key) {
            var optionsInput = model.getEntry(mode, key);
            if (optionsInput.nested || optionsInput.type === EntryTypes.TABLE || optionsInput.type === EntryTypes.CARDS) {
                group[key] = _this.createFormGroup(model[key], mode);
            }
            else {
                var value = data[key] ? data[key] : (model[key] != null ? model[key] :
                    optionsInput.default ? optionsInput.default : null);
                group[key] = new FormControl(value, Validators.compose(optionsInput.validators ? optionsInput.validators : []));
                if (optionsInput.onChanges) {
                    group[key].valueChanges.subscribe(function (value) {
                        console.log('ngx.form-generator.service/optionsInput.onChanges', value);
                        setTimeout(function () { return optionsInput.onChanges(value, formGroup); });
                    });
                }
            }
        });
        var formGroup = new FormGroup(group);
        if (model.getFormOptions && model.getFormOptions(mode) && model.getFormOptions(mode).onChanges) {
            formGroup.valueChanges.subscribe(function (value) {
                model.getFormOptions(mode).onChanges(value, formGroup, model);
            });
        }
        return formGroup;
    };
    return FormGeneratorService;
}());
FormGeneratorService.decorators = [
    { type: Injectable },
];
FormGeneratorService.ctorParameters = function () { return []; };
var TableMode = {
    EDITABLE: 'editable',
    SELECTABLE: 'selectable',
};
var TableButton = {
    CONSULT: 'consult',
    EDIT: 'edit',
    DELETE: 'delete',
    ADD: 'add',
    COPY: 'copy',
    SAVE: 'save',
    PRINT: 'print',
    DOWNLOAD: 'download',
    COURS: 'cours',
    TRANSFER: 'transfer',
    EMAIL: 'email',
    CALC: 'calcul',
    STUDENT: 'student',
    FAMILY: 'family',
};
var AutoTableComponent = /** @class */ (function () {
    function AutoTableComponent(formGenerator, changeDetectorRef) {
        this.formGenerator = formGenerator;
        this.changeDetectorRef = changeDetectorRef;
        this.TableMode = TableMode;
        this.TableButton = TableButton;
        this.selectRows = new EventEmitter();
        this.consult = new EventEmitter();
        this.save = new EventEmitter();
        this.calcul = new EventEmitter();
        this.edit = new EventEmitter();
        this.copy = new EventEmitter();
        this.add = new EventEmitter();
        this.print = new EventEmitter();
        this.download = new EventEmitter();
        this.delete = new EventEmitter();
        this.cours = new EventEmitter();
        this.transfer = new EventEmitter();
        this.email = new EventEmitter();
        this.student = new EventEmitter();
        this.family = new EventEmitter();
        this.cellSave = new EventEmitter();
        this.cellClick = new EventEmitter();
        this.sort = new EventEmitter();
        this.sortType = 'single';
        this.selected = [];
        this.limit = 20;
        this.editingChange = new EventEmitter();
        this.footerHeight = 35;
        this.headerHeight = 35;
        this.rowHeight = 'auto';
        this.scrollbarV = false;
        this.tableHeight = 'auto';
        this.isEditable = true;
        this.defaultMessages = {
            emptyMessage: 'Aucune donnée disponible',
            selectedMessage: 'sélectionné(s)',
            totalMessage: 'ligne(s)',
        };
        this.datatableRows = [];
    }
    AutoTableComponent.prototype.ngOnInit = function () {
    };
    AutoTableComponent.prototype.ngOnChanges = function (changes) {
        if (!!changes['model']) {
            this.initTable(changes);
        }
        if (!!changes['rows']) {
            this.initRows(changes);
        }
        if (!!changes['tableHeight'] && this.dataTable.element) {
            this.dataTable.element.style.height = this.tableHeight + 'px';
        }
    };
    AutoTableComponent.prototype.onResizeContainer = function () {
    };
    AutoTableComponent.prototype.initRows = function (changes) {
        var _this = this;
        var _a = changes['rows'], currentValue = _a.currentValue, previousValue = _a.previousValue, firstChange = _a.firstChange;
        if (!!currentValue && previousValue != currentValue && currentValue instanceof Array) {
            var tableRows_1 = [];
            this.rows.forEach(function (row) {
                tableRows_1.push(row);
            });
            setTimeout(function () {
                _this.columns = __spread(_this.columns);
                _this.datatableRows = tableRows_1;
            }, 10);
        }
    };
    AutoTableComponent.prototype.initTable = function (changes) {
        var _this = this;
        var _a = changes['model'], currentValue = _a.currentValue, previousValue = _a.previousValue, firstChange = _a.firstChange;
        if (!!currentValue && currentValue !== previousValue) {
            var columns_1 = [];
            if (this.rowDetails && this.rowDetails.template) {
                columns_1.push({
                    name: '',
                    prop: 'expand',
                    cellTemplate: this.expandDetailsTemplate,
                    width: 10,
                    resizeable: false,
                    sortable: false,
                    draggable: false,
                    canAutoResize: false,
                });
            }
            this.model.getProperties(this.mode)
                .filter(function (property) { return !_this.model.getEntry(_this.mode, property).hidden; })
                .map(function (property) { return (_this.model.getEntry(_this.mode, property)); })
                .sort(function (a, b) {
                return (a.colOrder && b.colOrder) ?
                    a.colOrder - b.colOrder :
                    a.colOrder ?
                        1 :
                        b.colOrder ?
                            -1 : 0;
            })
                .filter(function (entry) {
                var currentBreakpoint = _this.currentBreakpoint();
                if (!_this.rowDetails)
                    return true;
                else if (!_this.rowDetails.hiddenCols[currentBreakpoint])
                    return true;
                else if (!_this.rowDetails.hiddenCols[currentBreakpoint].includes(entry.propertyName))
                    return true;
                else
                    return false;
            })
                .forEach(function (entry) {
                var column = {
                    name: entry.label,
                    prop: entry.propertyName,
                    minWidth: entry.minWidth,
                    maxWidth: entry.maxWidth,
                    width: entry.width,
                    cellTemplate: _this.cellTemplate,
                    flexGrow: entry.flexGrow,
                    isEditable: entry.isEditable,
                };
                columns_1.push(column);
            });
            if (this.buttons && this.buttons.length) {
                columns_1.push({
                    name: 'Actions',
                    prop: 'actions',
                    cellTemplate: this.actionsTemplate,
                    minWidth: this.getActionsWidth(),
                });
            }
            this.columns = columns_1;
        }
        this.dataTable.recalculate();
    };
    AutoTableComponent.prototype.recalculate = function () {
        this.dataTable.recalculate();
    };
    AutoTableComponent.prototype.onSelect = function (_a) {
        var selected = _a.selected;
        if (!!selected) {
            this.selected = __spread(selected);
            this.selectRows.next(selected);
        }
    };
    AutoTableComponent.prototype.onBlur = function (rowIndex, row, column) {
        this.onKeyPress(null, rowIndex, row, column);
    };
    AutoTableComponent.prototype.onFocus = function (rowIndex, row, column) {
    };
    AutoTableComponent.prototype.onCellClick = function (event, column, rowIndex, row) {
        if (this.isEditable && this.model.getEntry(this.mode, column.prop)['isEditable']) {
            if (this.editing == null || !this.forms.at(this.editing.rowIndex).get(this.editing.column.prop).invalid) {
                if (this.editing != null && (this.editing.column.prop !== column.prop || this.editing.rowIndex !== rowIndex)) {
                    console.log('oui on enregistre : emitCellSave', { row: row, rowIndex: rowIndex, column: column });
                    this.emitCellSave({ row: row, rowIndex: this.editing.rowIndex, column: this.editing.column });
                }
                this.editing = { rowIndex: rowIndex, column: column };
                this.editingChange.emit(this.editing);
            }
            this.cellClick.emit({ rowIndex: rowIndex, row: row, column: column });
        }
    };
    AutoTableComponent.prototype.onKeyPress = function (key, rowIndex, row, column) {
        console.log('AutoTableComponent.onKeyPress', { colprop: column.prop, row: row, rowForm: this.forms.at(rowIndex).value, rowIndex: rowIndex });
        if (this.editing) {
            var isValid = !this.forms.at(this.editing.rowIndex).get(this.editing.column.prop).invalid;
            if (key === null || key === 'enter') {
                this.emitCellSave({ row: row, rowIndex: rowIndex, column: column });
                this.editing = isValid ? null : this.editing;
                this.editingChange.emit(this.editing);
            }
            else if (key === 'esc') {
                this.forms.at(rowIndex).get(this.editing.column.prop).patchValue(row[this.editing.column.prop]);
                this.editing = null;
                this.editingChange.emit(this.editing);
            }
            else if (key === 'tab') {
                this.emitCellSave({ row: row, rowIndex: rowIndex, column: column });
                if (isValid) {
                    this.setNextEditable(rowIndex, column);
                    this.editingChange.emit(this.editing);
                }
            }
            else if (key === 'shifttab') {
                this.emitCellSave({ row: row, rowIndex: rowIndex, column: column });
                if (isValid) {
                    this.setPreviousEditable(rowIndex, column);
                    this.editingChange.emit(this.editing);
                }
            }
        }
        event.preventDefault();
        event.stopPropagation();
    };
    AutoTableComponent.prototype.setNextEditable = function (rowIndex, column) {
        var editableCols = this.columns.filter(function (col) { return col['isEditable']; });
        var colIndex = editableCols.findIndex(function (col) { return col.prop === column.prop; });
        if (colIndex < editableCols.length - 1) {
            this.editing = {
                rowIndex: rowIndex,
                column: editableCols[colIndex + 1]
            };
        }
        else {
            if (this.forms.at(rowIndex + 1)) {
                this.editing = {
                    rowIndex: rowIndex + 1,
                    column: editableCols[0],
                };
            }
            else {
                this.editing = null;
            }
        }
    };
    AutoTableComponent.prototype.setPreviousEditable = function (rowIndex, column) {
        var editableCols = this.columns.filter(function (col) { return col['isEditable']; });
        var colIndex = editableCols.findIndex(function (col) { return col.prop === column.prop; });
        if (colIndex < 1) {
            if (rowIndex >= 0) {
                this.editing = {
                    rowIndex: rowIndex - 1,
                    column: editableCols[editableCols.length - 1],
                };
            }
            else {
                this.editing = null;
            }
        }
        else {
            this.editing = {
                rowIndex: rowIndex,
                column: editableCols[colIndex - 1],
            };
        }
    };
    AutoTableComponent.prototype.onEdit = function (rowIndex, row) {
        this.triggerActionCallback(TableButton.EDIT, { rowIndex: rowIndex, row: row });
        this.edit.emit({ rowIndex: rowIndex, row: row });
        event.preventDefault();
        event.stopPropagation();
    };
    AutoTableComponent.prototype.onPrint = function (rowIndex, row) {
        this.triggerActionCallback(TableButton.PRINT, { rowIndex: rowIndex, row: row });
        this.print.emit({ rowIndex: rowIndex, row: row });
        event.preventDefault();
        event.stopPropagation();
    };
    AutoTableComponent.prototype.onDownload = function (rowIndex, row) {
        this.triggerActionCallback(TableButton.DOWNLOAD, { rowIndex: rowIndex, row: row });
        this.download.emit({ rowIndex: rowIndex, row: row });
        event.preventDefault();
        event.stopPropagation();
    };
    AutoTableComponent.prototype.onCopy = function (rowIndex, row) {
        this.triggerActionCallback(TableButton.COPY, { rowIndex: rowIndex, row: row });
        this.copy.emit({ rowIndex: rowIndex, row: row });
        event.preventDefault();
        event.stopPropagation();
    };
    AutoTableComponent.prototype.onCours = function (rowIndex, row) {
        this.triggerActionCallback(TableButton.COURS, { rowIndex: rowIndex, row: row });
        this.cours.emit({ rowIndex: rowIndex, row: row });
        event.preventDefault();
        event.stopPropagation();
    };
    AutoTableComponent.prototype.onTransfer = function (rowIndex, row) {
        this.triggerActionCallback(TableButton.TRANSFER, { rowIndex: rowIndex, row: row });
        this.transfer.emit({ rowIndex: rowIndex, row: row });
        event.preventDefault();
        event.stopPropagation();
    };
    AutoTableComponent.prototype.onEmail = function (rowIndex, row) {
        this.triggerActionCallback(TableButton.EMAIL, { rowIndex: rowIndex, row: row });
        this.email.emit({ rowIndex: rowIndex, row: row });
        event.preventDefault();
        event.stopPropagation();
    };
    AutoTableComponent.prototype.onConsult = function (rowIndex, row) {
        this.triggerActionCallback(TableButton.CONSULT, { rowIndex: rowIndex, row: row });
        this.consult.emit({ rowIndex: rowIndex, row: row });
        event.preventDefault();
        event.stopPropagation();
    };
    AutoTableComponent.prototype.onStudent = function (rowIndex, row) {
        this.triggerActionCallback(TableButton.STUDENT, { rowIndex: rowIndex, row: row });
        this.student.emit({ rowIndex: rowIndex, row: row });
        event.preventDefault();
        event.stopPropagation();
    };
    AutoTableComponent.prototype.onFamily = function (rowIndex, row) {
        this.triggerActionCallback(TableButton.FAMILY, { rowIndex: rowIndex, row: row });
        this.family.emit({ rowIndex: rowIndex, row: row });
        event.preventDefault();
        event.stopPropagation();
    };
    AutoTableComponent.prototype.onSave = function (rowIndex, row) {
        this.triggerActionCallback(TableButton.SAVE, { rowIndex: rowIndex, row: row });
        this.save.emit({ rowIndex: rowIndex, row: row });
    };
    AutoTableComponent.prototype.onCalculate = function (rowIndex, row) {
        this.triggerActionCallback(TableButton.CALC, { rowIndex: rowIndex, row: row });
        this.calcul.emit({ rowIndex: rowIndex, row: row });
    };
    AutoTableComponent.prototype.onDelete = function (rowIndex, row) {
        var item = null;
        if (this.parentModel && this.parentForm) {
            var entry = this.parentModel.getEntry(this.mode, this.propertyName);
            if (entry.removeCallback) {
                entry.removeCallback(item[0], this.parentForm);
            }
            if (entry.actionCallback) {
                entry.actionCallback(TableButton.DELETE, { rowIndex: rowIndex, row: row }, this.parentForm);
            }
        }
        this.delete.emit({ rowIndex: rowIndex, row: row });
        event.preventDefault();
        event.stopPropagation();
    };
    AutoTableComponent.prototype.onAddRow = function () {
        var newForm = this.formGenerator.createFormGroup(this.model, this.mode);
        this.forms.push(newForm);
        this.datatableRows = __spread(this.datatableRows, [newForm.value]);
        if (this.parentModel && this.parentForm) {
            var entry = this.parentModel.getEntry(this.mode, this.propertyName);
            if (entry.addCallback) {
                entry.addCallback(this.model, newForm);
            }
            if (entry.actionCallback) {
                entry.actionCallback(TableButton.DELETE, { rowIndex: this.datatableRows.length - 1, row: this.model }, this.parentForm);
            }
        }
    };
    AutoTableComponent.prototype.toggleExpandRow = function (row, event) {
        this.dataTable.rowDetail.toggleExpandRow(row);
        event.preventDefault();
        event.stopPropagation();
    };
    AutoTableComponent.prototype.onDetailToggle = function (event) {
    };
    AutoTableComponent.prototype.onSort = function (event) {
        console.log('Datatable OnSort : ', { event: event, rows: this.dataTable._internalRows });
        this.sort.emit(this.dataTable._internalRows);
    };
    AutoTableComponent.prototype.getActionsWidth = function () {
        return this.buttons ? this.buttons.filter(function (x) { return x != TableButton.ADD; }).length * 50 : 0;
    };
    AutoTableComponent.prototype.isButtonInList = function (value) {
        return this.buttons ? this.buttons.includes(value) : false;
    };
    AutoTableComponent.prototype.currentBreakpoint = function () {
        var _this = this;
        var breakpoint = 'xs';
        ['xs', 'sm', 'md', 'lg'].forEach(function (bp) {
            if (_this.isBreakpoint(bp)) {
                breakpoint = bp;
            }
        });
        return breakpoint;
    };
    AutoTableComponent.prototype.isBreakpoint = function (alias) {
        return getComputedStyle(this["device" + alias].nativeElement).display !== 'none';
    };
    AutoTableComponent.prototype.isCellEditing = function (column, rowIndex) {
        return this.tableMode === TableMode.EDITABLE
            && this.editing
            && this.editing.column.prop === column.prop
            && this.editing.rowIndex === rowIndex;
    };
    AutoTableComponent.prototype.triggerActionCallback = function (action, event) {
        if (this.parentModel && this.parentForm) {
            var entry = this.parentModel.getEntry(this.mode, this.propertyName);
            if (entry.actionCallback) {
                entry.actionCallback(action, event, this.parentForm);
            }
        }
    };
    AutoTableComponent.prototype.emitCellSave = function (_a) {
        var row = _a.row, rowIndex = _a.rowIndex, column = _a.column;
        console.log('emitCellSave', { row: row, rowIndex: rowIndex, column: column });
        if (this.forms.at(this.editing.rowIndex).get(this.editing.column.prop).value
            != this.dataTable._internalRows[this.editing.rowIndex][this.editing.column.prop]) {
            console.log('##### Cellule modifiée', { row: row, rowIndex: rowIndex, column: column, rowForm: this.forms.at(this.editing.rowIndex).value });
            this.cellSave.emit({
                rowIndex: rowIndex,
                row: this.forms.at(this.editing.rowIndex).value,
                column: column
            });
        }
    };
    return AutoTableComponent;
}());
AutoTableComponent.decorators = [
    { type: Component, args: [{
                selector: 'auto-table',
                template: "<div [class]=\"(tableMode==TableMode.EDITABLE ? 'editable ' : '')\">\n    <!-- (resized)=\"initTable()\" -->\n\n        <button\n            *ngIf=\"isButtonInList(TableButton.ADD)\"\n            (click)=\"onAddRow()\"\n            class=\"btn btn-labeled btn-info\"\n            type=\"button\">\n            <span class=\"btn-label\">\n                <i class=\"fa fa-plus\"></i>\n            </span>Ajouter\n        </button>\n\n<!--class=\"material striped\"-->\n    <ngx-datatable\n        #dataTable\n        class=\"material striped\"\n        [rows]=\"datatableRows\"\n        [columns]=\"columns\"\n        [columnMode]=\"columnMode\"\n        [headerHeight]=\"headerHeight\"\n        [footerHeight]=\"footerHeight\"\n        [selectionType]=\"selectionType\"\n        [selected]=\"selected\"\n        [messages]=\"messages || defaultMessages\"\n        [rowHeight]=\"rowHeight\"\n        [scrollbarV]=\"scrollbarV\"\n        [limit]=\"limit\"\n        [sortType]=\"sortType\"\n        (sort)=\"onSort($event)\"\n        (select)=\"onSelect($event)\">\n        <!-- [scrollbarH]=\"true\" -->\n\n        <!-- Row detail management -->\n        <ng-container *ngIf=\"rowDetails && rowDetails.template\">\n            <ngx-datatable-row-detail [rowHeight]=\"'auto'\" [width]=\"10\" #detailRow (toggle)=\"onDetailToggle($event)\">\n                <ng-template let-row=\"row\" let-expanded=\"expanded\" ngx-datatable-row-detail-template>\n                    <ng-container *ngTemplateOutlet=\"rowDetails.template;context:{'row': row}\">\n                    </ng-container>\n                </ng-template>\n            </ngx-datatable-row-detail>\n        </ng-container>\n\n        <!-- Customize footer for editable tables -->\n        <ngx-datatable-footer *ngIf=\"!!footerTemplate\">\n            <ng-template\n                ngx-datatable-footer-template\n                let-rowCount=\"rowCount\"\n                let-pageSize=\"pageSize\"\n                let-curPage=\"curPage\"\n                let-offset=\"offset\">\n                <ng-container *ngTemplateOutlet=\"footerTemplate;context:{'rowCount': rowCount, 'pageSize': pageSize, 'curPage': curPage, 'offset': offset}\">\n                </ng-container>\n\n            </ng-template>\n        </ngx-datatable-footer>\n    </ngx-datatable>\n</div>\n\n<!-- Template for actions column -->\n<ng-template\n    #actionsTemplate\n    let-row=\"row\"\n    let-rowIndex=\"rowIndex\"\n    let-value=\"value\"\n    ngx-datatable-cell-template>\n\n    <button\n        *ngIf=\"isButtonInList(TableButton.CONSULT)\"\n        (dblclick)=\"onConsult(rowIndex)\"\n        (click)=\"onConsult(rowIndex, row)\"\n        title=\"Consulter\"\n        class=\"icon-solo btn btn-labeled btn-info btn-sm\"\n        type=\"button\">\n\n        <span class=\"btn-label\">\n            <i class=\"fa fa-search\"></i>\n        </span>\n    </button>\n\n    <button\n        *ngIf=\"isButtonInList(TableButton.EDIT)\"\n        (dblclick)=\"onEdit(rowIndex, row)\"\n        (click)=\"onEdit(rowIndex, row)\"\n        title=\"Modifier\"\n        class=\"icon-solo btn btn-labeled btn-warning btn-sm\"\n        type=\"button\">\n\n        <span class=\"btn-label\">\n            <i class=\"fa fa-edit\"></i>\n        </span>\n    </button>\n\n    <button\n        *ngIf=\"isButtonInList(TableButton.SAVE)\"\n        (dblclick)=\"onSave(rowIndex, row)\"\n        (click)=\"onSave(rowIndex, row)\"\n        title=\"Sauvegarder\"\n        class=\"icon-solo btn btn-labeled btn-danger btn-sm\"\n        type=\"button\">\n\n        <span class=\"btn-label\">\n            <i class=\"fa fa-save\"></i>\n        </span>\n    </button>\n\n    <button\n        *ngIf=\"isButtonInList(TableButton.CALC)\"\n        (dblclick)=\"onCalculate(rowIndex, row)\"\n        (click)=\"onCalculate(rowIndex, row)\"\n        title=\"Calculer\"\n        class=\"icon-solo btn btn-labeled btn-danger btn-sm\"\n        type=\"button\">\n        <span class=\"btn-label\">\n            <i class=\"fa fa-calculator\"></i>\n        </span>\n    </button>\n\n    <button\n        *ngIf=\"isButtonInList(TableButton.COPY)\"\n        (dblclick)=\"onCopy(rowIndex, row)\"\n        (click)=\"onCopy(rowIndex, row)\"\n        title=\"Copier\"\n        class=\"icon-solo btn btn-labeled btn-warning btn-sm\"\n        type=\"button\">\n\n        <span class=\"btn-label\">\n            <i class=\"fa fa-copy\"></i>\n        </span>\n    </button>\n\n    <button\n        *ngIf=\"isButtonInList(TableButton.PRINT)\"\n        (dblclick)=\"onPrint(rowIndex, row)\"\n        (click)=\"onPrint(rowIndex, row)\"\n        title=\"Imprimer\"\n        class=\"icon-solo btn btn-labeled btn-success btn-sm\"\n        type=\"button\">\n\n        <span class=\"btn-label\">\n            <i class=\"fa fa-print\"></i>\n        </span>\n    </button>\n\n    <button\n        *ngIf=\"isButtonInList(TableButton.COURS)\"\n        (dblclick)=\"onCours(rowIndex, row)\"\n        (click)=\"onCours(rowIndex, row)\"\n        class=\"icon-solo btn btn-labeled btn-primary btn-sm\"\n        title=\"Inscrire \u00E0 un cours\"\n        type=\"button\">\n\n        <span class=\"btn-label\">\n            <i class=\"fa fa-music\"></i>\n        </span>\n    </button>\n\n    <button\n        *ngIf=\"isButtonInList(TableButton.TRANSFER)\"\n        (dblclick)=\"onTransfer(rowIndex, row)\"\n        (click)=\"onTransfer(rowIndex, row)\"\n        title=\"Transf\u00E9rer vers un cours\"\n        class=\"icon-solo btn btn-labeled btn-primary btn-sm\"\n        type=\"button\">\n\n        <span class=\"btn-label\">\n            <i class=\"fa fa-user-plus\"></i>\n        </span>\n    </button>\n\n    <button\n        *ngIf=\"isButtonInList(TableButton.EMAIL)\"\n        (dblclick)=\"onEmail(rowIndex, row)\"\n        (click)=\"onEmail(rowIndex, row)\"\n        class=\"icon-solo btn btn-labeled btn-primary btn-sm\"\n        title=\"Ecrire un message\"\n        type=\"button\">\n\n        <span class=\"btn-label\">\n            <i class=\"fa fa-envelope\"></i>\n        </span>\n    </button>\n\n    <ng-container *ngIf=\"isButtonInList(TableButton.DOWNLOAD)\">\n        <button\n            *ngIf=\"!downloadTemplate\"\n            (dblclick)=\"onDownload(rowIndex, row)\"\n            (click)=\"onDownload(rowIndex, row)\"\n            class=\"icon-solo btn btn-labeled btn-success btn-sm\"\n            title=\"T\u00E9l\u00E9charger\"\n            type=\"button\">\n\n            <span class=\"btn-label\">\n                <i class=\"fa fa-download\"></i>\n            </span>\n        </button>\n\n        <ng-container *ngIf=\"!!downloadTemplate\"\n            [ngTemplateOutlet]=\"downloadTemplate\"\n            [ngTemplateOutletContext]=\"{'row': row}\">\n        </ng-container>\n    </ng-container>\n\n    <button\n        *ngIf=\"isButtonInList(TableButton.DELETE)\"\n        (dblclick)=\"onDelete(rowIndex)\"\n        (click)=\"onDelete(rowIndex, row)\"\n        class=\"icon-solo btn btn-labeled btn-danger btn-sm\"\n        title=\"Supprimer\"\n        type=\"button\">\n        <span class=\"btn-label\">\n            <i class=\"fa fa-trash\"></i>\n        </span>\n    </button>\n\n    <button\n        *ngIf=\"isButtonInList(TableButton.STUDENT)\"\n        (dblclick)=\"onStudent(rowIndex)\"\n        (click)=\"onStudent(rowIndex, row)\"\n        class=\"icon-solo btn btn-labeled btn-danger btn-sm\"\n        title=\"El\u00E8ve\"\n        type=\"button\">\n        <span class=\"btn-label\">\n            <i class=\"fa fa-user\"></i>\n        </span>\n    </button>\n\n    <button\n        *ngIf=\"isButtonInList(TableButton.FAMILY)\"\n        (dblclick)=\"onFamily(rowIndex)\"\n        (click)=\"onFamily(rowIndex, row)\"\n        class=\"icon-solo btn btn-labeled btn-danger btn-sm\"\n        title=\"Famille\"\n        type=\"button\">\n        <span class=\"btn-label\">\n            <i class=\"fa fa-users\"></i>\n        </span>\n    </button>\n</ng-template>\n\n<!-- Template for a cell -->\n<ng-template\n    #cellTemplate\n    let-row=\"row\"\n    let-rowIndex=\"rowIndex\"\n    let-value=\"value\"\n    let-column=\"column\"\n    ngx-datatable-cell-template>\n    <span class=\"cell-content\" (click)=\"onCellClick($event, column, rowIndex, row)\" (dblclick)=\"$event.stopPropagation();\">\n        <ng-container *ngIf=\"!isCellEditing(column, rowIndex)\">\n            <ng-template #defaultTemplate let-value=\"value\" let-row=\"row\">\n                {{\n                    model.getEntry(mode, column.prop).transform ?\n                        model.getEntry(mode, column.prop).transform(value, row) :\n                        value\n                }}\n            </ng-template>\n            <ng-container\n                *ngTemplateOutlet=\"rowsTemplates && rowsTemplates[column.prop] ?\n                    rowsTemplates[column.prop] : defaultTemplate;\n                    context:{'value': value, 'row': row};\">\n            </ng-container>\n        </ng-container>\n\n        <form-input\n            *ngIf=\"isCellEditing(column, rowIndex)\"\n            [autofocus]=\"true\"\n            [model]=\"model\"\n            [mode]=\"mode\"\n            [propertyName]=\"column.prop\"\n            [form]=\"forms.controls[rowIndex]\"\n            [fromTable]=\"true\"\n            (keydown.tab)=\"onKeyPress('tab', rowIndex, row, column)\"\n            (keydown.esc)=\"onKeyPress('esc', rowIndex, row, column)\"\n            (keydown.enter)=\"onKeyPress('enter', rowIndex, row, column)\"\n            (keydown.shift.tab)=\"onKeyPress('shifttab', rowIndex, row, column)\"\n            (blur)=\"onBlur(rowIndex, row, column)\"\n            (focus)=\"onFocus(rowIndex, row, column)\"\n            >\n        </form-input>\n    </span>\n</ng-template>\n\n<ng-template #expandDetailsTemplate let-row=\"row\" let-expanded=\"expanded\" ngx-datatable-cell-template>\n    <span\n        [class.datatable-icon-right]=\"!expanded\"\n        [class.datatable-icon-down]=\"expanded\"\n        title=\"Expand/Collapse Row\"\n        (click)=\"toggleExpandRow(row, $event)\">\n    </span>\n</ng-template>\n\n<div #devicexs class=\"visible-xs\"></div>\n<div #devicesm class=\"visible-sm\"></div>\n<div #devicemd class=\"visible-md\"></div>\n<div #devicelg class=\"visible-lg\"></div>",
                styles: ["\n        .cell-content .form-control {\n            padding:2px !important;\n            height: auto;\n        }\n        .cell-content, .datatable-body-cell-label {\n            display: block;\n            width: 100%;\n            height: 100%;\n        }\n    "],
                encapsulation: ViewEncapsulation.None
            },] },
];
AutoTableComponent.ctorParameters = function () { return [
    { type: FormGeneratorService, },
    { type: ChangeDetectorRef, },
]; };
AutoTableComponent.propDecorators = {
    "dataTable": [{ type: ViewChild, args: ['dataTable',] },],
    "expandDetailsTemplate": [{ type: ViewChild, args: ['expandDetailsTemplate',] },],
    "actionsTemplate": [{ type: ViewChild, args: ['actionsTemplate',] },],
    "cellTemplate": [{ type: ViewChild, args: ['cellTemplate',] },],
    "devicexs": [{ type: ViewChild, args: ['devicexs',] },],
    "devicesm": [{ type: ViewChild, args: ['devicesm',] },],
    "devicemd": [{ type: ViewChild, args: ['devicemd',] },],
    "devicelg": [{ type: ViewChild, args: ['devicelg',] },],
    "selectRows": [{ type: Output },],
    "consult": [{ type: Output },],
    "save": [{ type: Output },],
    "calcul": [{ type: Output },],
    "edit": [{ type: Output },],
    "copy": [{ type: Output },],
    "add": [{ type: Output },],
    "print": [{ type: Output },],
    "download": [{ type: Output },],
    "delete": [{ type: Output },],
    "cours": [{ type: Output },],
    "transfer": [{ type: Output },],
    "email": [{ type: Output },],
    "student": [{ type: Output },],
    "family": [{ type: Output },],
    "cellSave": [{ type: Output },],
    "cellClick": [{ type: Output },],
    "sort": [{ type: Output },],
    "sortType": [{ type: Input },],
    "tableMode": [{ type: Input },],
    "parentModel": [{ type: Input },],
    "parentForm": [{ type: Input },],
    "model": [{ type: Input },],
    "mode": [{ type: Input },],
    "rows": [{ type: Input },],
    "selected": [{ type: Input },],
    "limit": [{ type: Input },],
    "forms": [{ type: Input },],
    "editing": [{ type: Input },],
    "editingChange": [{ type: Output },],
    "propertyName": [{ type: Input },],
    "buttons": [{ type: Input },],
    "downloadTemplate": [{ type: Input },],
    "selectionType": [{ type: Input },],
    "columnMode": [{ type: Input },],
    "messages": [{ type: Input },],
    "rowsTemplates": [{ type: Input },],
    "rowDetails": [{ type: Input },],
    "footerTemplate": [{ type: Input },],
    "footerHeight": [{ type: Input },],
    "headerHeight": [{ type: Input },],
    "rowHeight": [{ type: Input },],
    "scrollbarV": [{ type: Input },],
    "tableHeight": [{ type: Input },],
    "isEditable": [{ type: Input },],
};
var CardMode = {
    EDIT: 'edit',
    SHOW: 'show',
};
var CardBox = /** @class */ (function () {
    function CardBox() {
    }
    return CardBox;
}());
var AutoCardsComponent = /** @class */ (function () {
    function AutoCardsComponent(formGenerator) {
        this.formGenerator = formGenerator;
        this.CardMode = CardMode;
    }
    AutoCardsComponent.prototype.ngOnChanges = function (changes) {
    };
    AutoCardsComponent.prototype.onAddCard = function () {
        var entry = this.parentModel.getEntry(this.mode, this.propertyName);
        var cardModel = entry.model;
        var newObject = new cardModel.prototype.constructor();
        if (newObject.initAfterCreate) {
            newObject.initAfterCreate(this);
        }
        var newForm = this.formGenerator.createFormGroup(newObject, this.mode);
        var forms = (this.parentForm.controls[this.propertyName]);
        forms.push(newForm);
        this.cards.push(newObject);
        if (entry.addCallback) {
            entry.addCallback(newObject, newForm);
        }
    };
    AutoCardsComponent.prototype.onRemoveCard = function (index) {
        var entry = this.parentModel.getEntry(this.mode, this.propertyName);
        var item = this.cards.splice(index, 1);
        var forms = (this.parentForm.controls[this.propertyName]);
        forms.removeAt(index);
        if (entry.removeCallback) {
            entry.removeCallback(item[0], this.parentForm);
        }
    };
    AutoCardsComponent.prototype.getCardBoxes = function () {
        return this.parentModel ?
            this.parentModel.getEntry(this.mode, this.propertyName).css.box :
            this.cardBox ?
                this.cardBox.css : '';
    };
    return AutoCardsComponent;
}());
AutoCardsComponent.decorators = [
    { type: Component, args: [{
                selector: 'auto-cards',
                template: "<ng-template #defaultButtons>\n    <button class=\"btn btn-labeled btn-info\" type=\"button\">\n        <div>\n            <span class=\"btn-label\">\n                <i class=\"fa fa-plus\"></i>\n            </span>\n            {{ parentModel.getEntry(mode, propertyName).addLabel }}\n        </div>\n    </button>\n</ng-template>\n\n<ng-template #defaultCloseButton let-index=\"index\">\n    <span class=\"fa fa-close pull-right\" style=\"font-size:20px;color:red\"></span>\n</ng-template>\n\n\n\n\n\n<div class=\"col-xs-12\">\n    <!-- <label *ngIf=\"parentModel && parentModel.getEntry(propertyName).label\"\n        [class]=\"parentModel.getEntry(propertyName).css.label\">\n        {{ parentModel.getEntry(propertyName).label }}\n    </label> -->\n    <span (click)=\"onAddCard()\">\n        <ng-container *ngTemplateOutlet=\"customButtons ? customButtons: defaultButtons\">\n        </ng-container>\n    </span>\n</div>\n\n<div class=\"col-xs-12\">\n    <div *ngFor=\"let card of cards; let index = index\"\n        [class]=\"getCardBoxes()\">\n\n        <div class=\"row panel-body\">\n            <div class=\"row\">\n\n                <div class=\"col-xs-12\">\n                    <b *ngIf=\"parentModel.getEntry(mode, propertyName).title\">\n                        {{ parentModel.getEntry(mode, propertyName).title }}\n                    </b>\n                    <span *ngIf=\"cardMode === CardMode.EDIT\"\n                        class=\"pull-right\"\n                        (click)=\"onRemoveCard(index)\">\n                        <ng-container\n                            *ngTemplateOutlet=\"customCloseButton ?\n                                customCloseButton:\n                                defaultCloseButton;context:{'index': index}\">\n                        </ng-container>\n                    </span>\n                </div>\n\n                <div *ngFor=\"let property of card.getProperties(mode)\"\n                    [class]=\"card.getEntry(mode, property).css.group\">\n\n                    <div *ngIf=\"cardMode === CardMode.EDIT\" class=\"row\">\n\n                        <form-input\n                            [model]=\"card\"\n                            [mode]=\"mode\"\n                            [propertyName]=\"property\"\n                            [form]=\"parentForm.controls[propertyName].controls[index]\">\n                        </form-input>\n\n                    </div>\n\n                    <div *ngIf=\"cardMode === CardMode.SHOW\">\n                        <label>\n                            {{ card.getEntry(mode, property).label }}\n                        </label>\n                        <p class=\"form-control-static\">\n                            {{ card[property] }}\n                        </p>\n                    </div>\n\n                </div>\n            </div> <!-- end class=\"row\" -->\n        </div>\n    </div>\n</div>",
                styles: ["\n        input.form-control {\n            padding:5px !important;\n        }\n    "]
            },] },
];
AutoCardsComponent.ctorParameters = function () { return [
    { type: FormGeneratorService, },
]; };
AutoCardsComponent.propDecorators = {
    "cardMode": [{ type: Input },],
    "customButtons": [{ type: Input },],
    "customCloseButton": [{ type: Input },],
    "parentForm": [{ type: Input },],
    "parentModel": [{ type: Input },],
    "mode": [{ type: Input },],
    "propertyName": [{ type: Input },],
    "cards": [{ type: Input },],
    "cardBox": [{ type: Input },],
};
var FormInputComponent = /** @class */ (function () {
    function FormInputComponent() {
        this.EntryTypes = EntryTypes;
        this.TableMode = TableMode;
        this.ColumnMode = ColumnMode;
        this.SelectionType = SelectionType;
        this.CardMode = CardMode;
        this.blur = new EventEmitter();
        this.focus = new EventEmitter();
    }
    FormInputComponent.prototype.onBlur = function () {
        this.blur.emit();
    };
    FormInputComponent.prototype.onFocus = function () {
        this.focus.emit();
    };
    FormInputComponent.prototype.ngOnChanges = function (changes) {
        if (this.mode && this.propertyName && this.model) {
            this.propertyMeta = this.model.getEntry(this.mode, this.propertyName);
        }
    };
    FormInputComponent.prototype.ngOnInit = function () {
    };
    FormInputComponent.prototype.isClassicInputField = function () {
        var INPUT_CONTROL_TYPES = [
            'text', 'number', 'email', 'tel', 'password'
        ];
        return this.propertyMeta && this.propertyMeta.type &&
            (INPUT_CONTROL_TYPES).includes(this.propertyMeta.type);
    };
    return FormInputComponent;
}());
FormInputComponent.decorators = [
    { type: Component, args: [{
                selector: 'form-input',
                template: "\n<div *ngIf=\"model && model.getEntry(mode, propertyName) && !model.getEntry(mode, propertyName).hidden\">\n\n    <div *ngIf=\"isClassicInputField()\">\n        <basic-input\n            [propertyName]=\"propertyName\"\n            [form]=\"form\"\n            [model]=\"model\"\n            [mode]=\"mode\"\n            [autofocus]=\"autofocus\"\n            [fromTable]=\"fromTable\"\n            (blur)=\"onBlur()\">\n        </basic-input>\n    </div>\n\n    <div *ngIf=\"propertyMeta && propertyMeta.type === EntryTypes.DATE\">\n        <date-input\n            [formControl]=\"form.controls[propertyName]\"\n            [propertyName]=\"propertyName\"\n            [form]=\"form\"\n            [model]=\"model\"\n            [mode]=\"mode\"\n            [autofocus]=\"autofocus\"\n            [fromTable]=\"fromTable\"\n            (blur)=\"onBlur()\"\n            (focus)=\"onFocus()\">\n        </date-input>\n    </div>\n\n    <div *ngIf=\"propertyMeta && propertyMeta.type === EntryTypes.TIME\">\n        <time-input\n            [formControl]=\"form.controls[propertyName]\"\n            [propertyName]=\"propertyName\"\n            [form]=\"form\"\n            [model]=\"model\"\n            [mode]=\"mode\"\n            [fromTable]=\"fromTable\">\n        </time-input>\n    </div>\n\n    <div *ngIf=\"propertyMeta && propertyMeta.type === EntryTypes.SELECT\">\n        <select-input\n            [propertyName]=\"propertyName\"\n            [autofocus]=\"autofocus\"\n            [form]=\"form\"\n            [model]=\"model\"\n            [mode]=\"mode\"\n            [fromTable]=\"fromTable\"\n            (blur)=\"onBlur()\"\n            (focus)=\"onFocus()\">\n        </select-input>\n    </div>\n\n    <div *ngIf=\"propertyMeta && propertyMeta.type === EntryTypes.RADIO\">\n        <radio-input\n            [propertyName]=\"propertyName\"\n            [form]=\"form\"\n            [model]=\"model\"\n            [mode]=\"mode\"\n            [fromTable]=\"fromTable\">\n        </radio-input>\n    </div>\n\n    <div *ngIf=\"propertyMeta && propertyMeta.type === EntryTypes.CHECKBOX\">\n        <checkbox-input\n            [propertyName]=\"propertyName\"\n            [autofocus]=\"autofocus\"\n            [form]=\"form\"\n            [model]=\"model\"\n            [mode]=\"mode\"\n            [fromTable]=\"fromTable\"\n            (blur)=\"onBlur()\">\n        </checkbox-input>\n    </div>\n\n    <div *ngIf=\"propertyMeta && propertyMeta.type === EntryTypes.TEXTAREA\">\n        <textarea-input\n            [propertyName]=\"propertyName\"\n            [form]=\"form\"\n            [model]=\"model\"\n            [mode]=\"mode\"\n            [autofocus]=\"autofocus\"\n            [fromTable]=\"fromTable\">\n        </textarea-input>\n    </div>\n\n    <div *ngIf=\"propertyMeta && propertyMeta.type === EntryTypes.COLOR\">\n        <color-input\n            [formControl]=\"form.controls[propertyName]\"\n            [propertyName]=\"propertyName\"\n            [form]=\"form\"\n            [model]=\"model\"\n            [mode]=\"mode\"\n            [autofocus]=\"autofocus\"\n            [fromTable]=\"fromTable\">\n        </color-input>\n    </div>\n\n    <div *ngIf=\"propertyMeta && propertyMeta.type === EntryTypes.BLANK\" [class]=\"propertyMeta.css.box\">\n      &nbsp;\n    </div>\n\n    <div *ngIf=\"propertyMeta && propertyMeta.type === EntryTypes.CARDS\">\n        <auto-cards\n            [mode]=\"mode\"\n            [cardMode]=\"propertyMeta.mode\"\n            [parentModel]=\"model\"\n            [parentForm]=\"form\"\n            [propertyName]=\"propertyName\"\n            [cards]=\"model[propertyName]\">\n        </auto-cards>\n    </div>\n\n    <div *ngIf=\"propertyMeta && propertyMeta.type === EntryTypes.STATIC\">\n        <static-input\n            [propertyName]=\"propertyName\"\n            [form]=\"form\"\n            [model]=\"model\"\n            [mode]=\"mode\"\n            [fromTable]=\"fromTable\">\n        </static-input>\n    </div>\n\n    <div *ngIf=\"propertyMeta && propertyMeta.type === EntryTypes.TABLE\" [class]=\"propertyMeta.css.box\">\n          <label *ngIf=\"propertyMeta.label\" [class]=\"propertyMeta.css.label\">\n              {{ propertyMeta.label }}\n          </label>\n          <auto-table\n              [class]=\"propertyMeta.css.input\"\n              [propertyName]=\"propertyName\"\n              [parentModel]=\"model\"\n              [parentForm]=\"form\"\n              [model]=\"propertyMeta.model.prototype.constructor()\"\n              [mode]=\"mode\"\n              [rows]=\"model[propertyName]\"\n              [forms]=\"form.controls[propertyName]\"\n              [tableMode]=\"TableMode.EDITABLE\"\n              [columnMode]=\"propertyMeta.columnMode ? propertyMeta.columnMode : ColumnMode.force\"\n              [buttons]=\"propertyMeta.buttons\">\n          </auto-table>\n    </div>\n\n</div>\n",
            },] },
];
FormInputComponent.ctorParameters = function () { return []; };
FormInputComponent.propDecorators = {
    "model": [{ type: Input },],
    "mode": [{ type: Input },],
    "form": [{ type: Input },],
    "propertyName": [{ type: Input },],
    "fromTable": [{ type: Input },],
    "autofocus": [{ type: Input },],
    "blur": [{ type: Output },],
    "focus": [{ type: Output },],
};
var Validations = /** @class */ (function () {
    function Validations() {
    }
    Validations.isControlValid = function (form, propertyName) {
        if (!form.controls[propertyName])
            console.log('NO FORMGROUP', { propertyName: propertyName, form: form });
        return form.controls[propertyName].invalid && form.controls[propertyName].touched;
    };
    return Validations;
}());
var BasicInputComponent = /** @class */ (function () {
    function BasicInputComponent(formGenerator) {
        this.formGenerator = formGenerator;
        this.EntryTypes = EntryTypes;
        this.Validations = Validations;
        this.blur = new EventEmitter();
    }
    BasicInputComponent.prototype.ngOnChanges = function (changes) {
        if (this.mode && this.propertyName) {
            this.propertyMeta = this.model.getEntry(this.mode, this.propertyName);
        }
    };
    BasicInputComponent.prototype.ngAfterViewInit = function () {
        if (this.autofocus)
            this.input.nativeElement.focus();
    };
    BasicInputComponent.prototype.onFocus = function (event) {
        if (this.autofocus && event.target.type != 'number') {
            event.target.selectionStart = 0;
            event.target.selectionEnd = 9999;
            event.target.select();
        }
    };
    BasicInputComponent.prototype.callOnClick = function () {
        if (typeof this.propertyMeta.onClick === 'function')
            this.propertyMeta.onClick();
    };
    BasicInputComponent.prototype.onBlur = function () {
        this.blur.emit();
    };
    return BasicInputComponent;
}());
BasicInputComponent.decorators = [
    { type: Component, args: [{
                selector: 'basic-input',
                template: "\n<div [formGroup]=\"form\" >\n    <div class=\"form-group\" [ngClass]=\"{'has-error': Validations.isControlValid(form, propertyName)}\">\n        <label *ngIf=\"!fromTable && propertyMeta.label\" [class]=\"'control-label ' + propertyMeta.css.label\">\n            {{propertyMeta.label}}\n        </label>\n        <div [class]=\"fromTable ? '' : propertyMeta.css.input\">\n            <div [ngClass]=\"{'input-group': propertyMeta.css.btn}\">\n                <input\n                    #input\n                    class=\"form-control\"\n                    [placeholder]=\"propertyMeta.placeholder ? propertyMeta.placeholder : ''\"\n                    [type]=\"propertyMeta.type\"\n                    [formControl]=\"form.controls[propertyName]\"\n                    [name]=\"propertyName\"\n                    (focus)=\"onFocus($event)\"\n                    (blur)=\"onBlur()\"\n                />\n\n                <span *ngIf=\"propertyMeta.css.btn\" class=\"input-group-btn\">\n                    <button type=\"button\" class=\"btn btn-default\" (click)=\"callOnClick()\">\n                        <i [class]=\"propertyMeta.css.btn\"></i>\n                    </button>\n                </span>\n            </div>\n        </div>\n\n        <validator-messages\n            [propertyName]=\"propertyName\"\n            [form]=\"form\"\n            [model]=\"model\"\n            [mode]=\"mode\">\n        </validator-messages>\n    </div>\n</div>",
            },] },
];
BasicInputComponent.ctorParameters = function () { return [
    { type: FormGeneratorService, },
]; };
BasicInputComponent.propDecorators = {
    "model": [{ type: Input },],
    "mode": [{ type: Input },],
    "form": [{ type: Input },],
    "propertyName": [{ type: Input },],
    "fromTable": [{ type: Input },],
    "autofocus": [{ type: Input },],
    "input": [{ type: ViewChild, args: ['input',] },],
    "blur": [{ type: Output },],
};
var SelectInputComponent = /** @class */ (function () {
    function SelectInputComponent(http, formGenerator, _cdr) {
        this.http = http;
        this.formGenerator = formGenerator;
        this._cdr = _cdr;
        this.Validations = Validations;
        this.blur = new EventEmitter();
        this.focus = new EventEmitter();
        this.defaultCompareFn = function (one, two) { return one === two; };
    }
    SelectInputComponent.prototype.ngOnChanges = function () {
        if (this.model && this.mode && this.propertyName) {
            this.propertyMeta = this.model.getEntry(this.mode, this.propertyName);
        }
    };
    SelectInputComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.propertyMeta = this.model.getEntry(this.mode, this.propertyName);
        if (this.autofocus) {
            this.input.nativeElement.focus();
        }
        var fetchOptions = this.propertyMeta.fetchOptions;
        if (fetchOptions) {
            if (this.subscription) {
                this.subscription.unsubscribe();
            }
            this.subscription = this.http
                .get(fetchOptions.url, fetchOptions.httpOptions(this.form.value))
                .subscribe(function (data) {
                _this.propertyMeta.options = fetchOptions.resMapper(data);
                if (fetchOptions.selectedIndex != null
                    && _this.propertyMeta.options.length > fetchOptions.selectedIndex) {
                    _this.form.controls[_this.propertyName]
                        .patchValue(_this.propertyMeta.options[fetchOptions.selectedIndex].value);
                }
            });
        }
    };
    SelectInputComponent.prototype.onBlur = function () {
        this.blur.emit();
    };
    SelectInputComponent.prototype.onFocus = function () {
        this.focus.emit();
    };
    SelectInputComponent.prototype.ngOnDestroy = function () {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    };
    return SelectInputComponent;
}());
SelectInputComponent.decorators = [
    { type: Component, args: [{
                selector: 'select-input',
                template: "<div [formGroup]=\"form\">\n    <div class=\"form-group\" [ngClass]=\"{'has-error': Validations.isControlValid(form, propertyName)}\">\n\n        <label *ngIf=\"!fromTable && propertyMeta.label\"\n            [class]=\"'control-label ' + propertyMeta.css.label\">\n            {{propertyMeta.label}}\n        </label>\n\n        <span [class]=\"propertyMeta.css.input\">\n            <select class=\"form-control\"\n                #input\n                [formControlName]=\"propertyName\"\n                [compareWith]=\"propertyMeta.compareFn ? propertyMeta.compareFn : defaultCompareFn\"\n                [name]=\"propertyName\"\n                (blur)=\"onBlur()\"\n                (focus)=\"onFocus()\">\n\n                <option *ngFor=\"let option of propertyMeta.options\" [ngValue]=\"option.value\">\n                    {{option.label}}\n                </option>\n\n            </select>\n        </span>\n\n        <validator-messages\n            [propertyName]=\"propertyName\"\n            [form]=\"form\"\n            [model]=\"model\"\n            [mode]=\"mode\">\n        </validator-messages>\n    </div>\n</div>",
            },] },
];
SelectInputComponent.ctorParameters = function () { return [
    { type: HttpClient, },
    { type: FormGeneratorService, },
    { type: ChangeDetectorRef, },
]; };
SelectInputComponent.propDecorators = {
    "model": [{ type: Input },],
    "mode": [{ type: Input },],
    "form": [{ type: Input },],
    "propertyName": [{ type: Input },],
    "fromTable": [{ type: Input },],
    "autofocus": [{ type: Input },],
    "input": [{ type: ViewChild, args: ['input',] },],
    "blur": [{ type: Output },],
    "focus": [{ type: Output },],
};
var RadioInputComponent = /** @class */ (function () {
    function RadioInputComponent(formGenerator) {
        this.formGenerator = formGenerator;
        this.Validations = Validations;
    }
    RadioInputComponent.prototype.ngOnChanges = function (changes) {
        if (this.mode && this.propertyName)
            this.propertyMeta = this.model.getEntry(this.mode, this.propertyName);
    };
    return RadioInputComponent;
}());
RadioInputComponent.decorators = [
    { type: Component, args: [{
                selector: 'radio-input',
                template: "<div [formGroup]=\"form\">\n    <div class=\"form-group\" [ngClass]=\"{'has-error': Validations.isControlValid(form, propertyName)}\">\n        <label *ngIf=\"!fromTable && propertyMeta.label\"\n            [class]=\"'control-label ' + propertyMeta.css.label\">\n            {{propertyMeta.label}}\n        </label>\n        <span *ngFor=\"let option of propertyMeta.options\" [class]=\"propertyMeta.css.input\">\n            <label>\n                <input\n                    type=\"radio\"\n                    [formControlName]=\"propertyName\"\n                    [name]=\"propertyName\"\n                    [value]=\"option.value\"\n                />\n                {{ option.label }}\n            </label>\n        </span>\n\n        <validator-messages\n            [propertyName]=\"propertyName\"\n            [form]=\"form\"\n            [model]=\"model\"\n            [mode]=\"mode\">\n        </validator-messages>\n    </div>\n</div>",
            },] },
];
RadioInputComponent.ctorParameters = function () { return [
    { type: FormGeneratorService, },
]; };
RadioInputComponent.propDecorators = {
    "model": [{ type: Input },],
    "mode": [{ type: Input },],
    "form": [{ type: Input },],
    "propertyName": [{ type: Input },],
    "fromTable": [{ type: Input },],
};
var CheckboxInputComponent = /** @class */ (function () {
    function CheckboxInputComponent(formGenerator) {
        this.formGenerator = formGenerator;
        this.Validations = Validations;
        this.blur = new EventEmitter();
    }
    CheckboxInputComponent.prototype.ngOnChanges = function (changes) {
        if (this.model && this.propertyName && this.mode) {
            this.propertyMeta = this.model.getEntry(this.mode, this.propertyName);
            var value = this.form.get(this.propertyName).value;
            this.checkboxes = typeof value == 'boolean' ?
                value :
                cloneDeep(value || []);
        }
    };
    CheckboxInputComponent.prototype.ngAfterViewInit = function () {
        if (this.autofocus) {
            this.input.nativeElement.focus();
        }
    };
    CheckboxInputComponent.prototype.handleClick = function (event, value) {
        this.handleChanges(event, value);
    };
    CheckboxInputComponent.prototype.handleChanges = function (event, value) {
        var checked = event.target.checked;
        if (this.propertyMeta.multiple) {
            if (checked) {
                this.checkboxes.push(value);
            }
            else {
                var index = this.checkboxes.indexOf(value);
                if (index == -1)
                    index = this.checkboxes.indexOf(parseInt(value));
                if (index > -1)
                    this.checkboxes.splice(index, 1);
            }
        }
        else {
            if (checked) {
                this.checkboxes = value;
            }
            else {
                this.checkboxes = null;
            }
        }
        this.form.controls[this.propertyName].patchValue(this.checkboxes);
        this.input.nativeElement.blur();
        this.blur.emit();
    };
    CheckboxInputComponent.prototype.isChecked = function (id) {
        var debug = this.checkboxes instanceof Array ? this.checkboxes.includes(id) : this.checkboxes === id;
        return debug;
    };
    return CheckboxInputComponent;
}());
CheckboxInputComponent.decorators = [
    { type: Component, args: [{
                selector: 'checkbox-input',
                template: "<div [formGroup]=\"form\">\n    <div class=\"form-group\" [ngClass]=\"{'has-error': Validations.isControlValid(form, propertyName)}\">\n        <label *ngIf=\"!fromTable && propertyMeta.label\"\n            [class]=\"'control-label ' + propertyMeta.css.label\">\n            {{propertyMeta.label}}\n        </label>\n\n        <label *ngFor=\"let option of propertyMeta.options; let i = index\"\n            [class]=\"'checkbox c-checkbox ' + propertyMeta.css.input\">\n            <input\n                #input\n                [type]=\"propertyMeta.type\"\n                (change)=\"handleChanges($event, option.value)\"\n                [value]=\"option.value\"\n                [checked]=\"isChecked(option.value)\"\n                [disabled]=\"option.disabled\"\n                (click)=\"handleClick($event, option.value)\"\n            />\n            <span class=\"fa fa-check\"></span>\n            {{ option.label }}\n        </label>\n\n        <validator-messages\n            [propertyName]=\"propertyName\"\n            [form]=\"form\"\n            [model]=\"model\"\n            [mode]=\"mode\">\n        </validator-messages>\n    </div>\n</div>\n",
            },] },
];
CheckboxInputComponent.ctorParameters = function () { return [
    { type: FormGeneratorService, },
]; };
CheckboxInputComponent.propDecorators = {
    "model": [{ type: Input },],
    "mode": [{ type: Input },],
    "form": [{ type: Input },],
    "propertyName": [{ type: Input },],
    "autofocus": [{ type: Input },],
    "fromTable": [{ type: Input },],
    "input": [{ type: ViewChild, args: ['input',] },],
    "blur": [{ type: Output },],
};
var TextareaInputComponent = /** @class */ (function () {
    function TextareaInputComponent(formGenerator) {
        this.formGenerator = formGenerator;
        this.EntryTypes = EntryTypes;
        this.Validations = Validations;
    }
    TextareaInputComponent.prototype.ngOnInit = function () {
        this.propertyMeta = this.model.getEntry(this.mode, this.propertyName);
    };
    TextareaInputComponent.prototype.ngAfterViewInit = function () {
        if (this.autofocus)
            this.input.nativeElement.focus();
    };
    TextareaInputComponent.prototype.onFocus = function (event) {
        if (this.autofocus) {
            event.target.selectionStart = 0;
            event.target.selectionEnd = 9999;
            event.target.select();
        }
    };
    return TextareaInputComponent;
}());
TextareaInputComponent.decorators = [
    { type: Component, args: [{
                selector: 'textarea-input',
                template: "<div [formGroup]=\"form\" >\n    <div class=\"form-group\" [ngClass]=\"{'has-error': Validations.isControlValid(form, propertyName)}\">\n        <label *ngIf=\"!fromTable && propertyMeta.label\" [class]=\"'control-label ' + propertyMeta.css.label\">\n            {{propertyMeta.label}}\n        </label>\n        <span [class]=\"fromTable ? '' : propertyMeta.css.input\">\n            <textarea\n                #input\n                class=\"form-control\"\n                [formControl]=\"form.controls[propertyName]\"\n                [name]=\"propertyName\"\n                (focus)=\"onFocus($event)\"\n            ></textarea>\n        </span>\n\n        <validator-messages\n            [propertyName]=\"propertyName\"\n            [form]=\"form\"\n            [model]=\"model\"\n            [mode]=\"mode\">\n        </validator-messages>\n    </div>\n</div>\n",
            },] },
];
TextareaInputComponent.ctorParameters = function () { return [
    { type: FormGeneratorService, },
]; };
TextareaInputComponent.propDecorators = {
    "model": [{ type: Input },],
    "mode": [{ type: Input },],
    "form": [{ type: Input },],
    "propertyName": [{ type: Input },],
    "fromTable": [{ type: Input },],
    "autofocus": [{ type: Input },],
    "input": [{ type: ViewChild, args: ['input',] },],
};
var ColorFormat = {
    NUMBER: 'number',
    RGB: 'rgb',
};
var ColorInputComponent = /** @class */ (function () {
    function ColorInputComponent(formGenerator) {
        this.formGenerator = formGenerator;
        this.EntryTypes = EntryTypes;
        this.Validations = Validations;
        this.onTouchedCallback = function () { };
        this.onChangeCallback = function () { };
    }
    Object.defineProperty(ColorInputComponent.prototype, "color", {
        get: function () {
            return this._color;
        },
        set: function (value) {
            switch (this.propertyMeta.format) {
                case ColorFormat.NUMBER:
                    this._color = value;
                    break;
                case ColorFormat.RGB:
                default:
                    this._color = value;
                    break;
            }
            this.onChangeCallback(this._color);
        },
        enumerable: true,
        configurable: true
    });
    ColorInputComponent.prototype.ngOnChanges = function (changes) {
        if (this.model && this.propertyName && this.mode) {
            this.propertyMeta = this.model.getEntry(this.mode, this.propertyName);
        }
    };
    ColorInputComponent.prototype.ngAfterViewInit = function () {
        if (this.autofocus)
            this.input.nativeElement.focus();
    };
    ColorInputComponent.prototype.onFocus = function (event) {
        if (this.autofocus) {
            event.target.selectionStart = 0;
            event.target.selectionEnd = 9999;
            event.target.select();
        }
    };
    ColorInputComponent.prototype.writeValue = function (value) {
        if (!value) {
            this._color = '';
            return;
        }
        switch (this.propertyMeta.format) {
            case ColorFormat.NUMBER:
                this._color = "#" + parseInt(value).toString(16);
                break;
            case ColorFormat.RGB:
            default:
                this._color = value;
                break;
        }
    };
    ColorInputComponent.prototype.registerOnChange = function (fn) {
        this.onChangeCallback = fn;
    };
    ColorInputComponent.prototype.registerOnTouched = function (fn) {
        this.onTouchedCallback = fn;
    };
    ColorInputComponent.prototype.setDisabledState = function (isDisabled) {
        this.disabled = isDisabled;
    };
    return ColorInputComponent;
}());
ColorInputComponent.decorators = [
    { type: Component, args: [{
                selector: 'color-input',
                template: "<div>\n    <div class=\"form-group\" [ngClass]=\"{'has-error': Validations.isControlValid(form, propertyName)}\">\n        <label *ngIf=\"!fromTable && propertyMeta.label\" [class]=\"'control-label ' + propertyMeta.css.label\">\n            {{propertyMeta.label}}\n        </label>\n        <div [class]=\"fromTable ? '' : propertyMeta.css.input\">\n\n            <input #input\n                class=\"form-control\"\n                [name]=\"propertyName\"\n                [style.background]=\"color\"\n                [value]=\"color ? color : ''\"\n                [cpPosition]=\"'bottom'\"\n                (focus)=\"onFocus($event)\"\n                [(colorPicker)]=\"color\"/>\n\n        </div>\n\n        <validator-messages\n            [propertyName]=\"propertyName\"\n            [form]=\"form\"\n            [model]=\"model\"\n            [mode]=\"mode\">\n        </validator-messages>\n    </div>\n</div>",
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: ColorInputComponent,
                        multi: true
                    }]
            },] },
];
ColorInputComponent.ctorParameters = function () { return [
    { type: FormGeneratorService, },
]; };
ColorInputComponent.propDecorators = {
    "model": [{ type: Input },],
    "mode": [{ type: Input },],
    "form": [{ type: Input },],
    "propertyName": [{ type: Input },],
    "fromTable": [{ type: Input },],
    "autofocus": [{ type: Input },],
    "input": [{ type: ViewChild, args: ['input',] },],
};
var moment = moment_;
var TimeFormat = {
    MINUTES: 'minutes',
    HOUR_MIN: 'hh:mm',
};
var TimeInputComponent = /** @class */ (function () {
    function TimeInputComponent() {
        this.EntryTypes = EntryTypes;
        this.Validations = Validations;
        this.onTouchedCallback = function () { };
        this.onChangeCallback = function () { };
    }
    Object.defineProperty(TimeInputComponent.prototype, "time", {
        get: function () {
            return this.timeModel;
        },
        set: function (time) {
            this.timeModel = time;
            switch (this.propertyMeta.format) {
                case TimeFormat.MINUTES:
                    var hh = moment(time).get('hour');
                    var mm = moment(time).get('minute');
                    this.onChangeCallback(hh * 60 + mm);
                    break;
                case TimeFormat.HOUR_MIN:
                default:
                    this.onChangeCallback(moment(this.timeModel).format('HH:mm'));
                    break;
            }
        },
        enumerable: true,
        configurable: true
    });
    TimeInputComponent.prototype.ngOnInit = function () {
        this.propertyMeta = this.model.getEntry(this.mode, this.propertyName);
    };
    TimeInputComponent.prototype.ngOnDestroy = function () {
    };
    TimeInputComponent.prototype.writeValue = function (value) {
        switch (this.propertyMeta.format) {
            case TimeFormat.MINUTES:
                if (!value)
                    this.timeModel = null;
                else {
                    var hours = Math.floor(value / 60);
                    var mins = value % 60;
                    this.timeModel = moment(hours + ":" + mins, 'HH:mm').toDate();
                }
                break;
            case TimeFormat.HOUR_MIN:
            default:
                this.timeModel = moment(value, 'HH:mm').toDate();
                break;
        }
    };
    TimeInputComponent.prototype.registerOnChange = function (fn) {
        this.onChangeCallback = fn;
    };
    TimeInputComponent.prototype.registerOnTouched = function (fn) {
        this.onTouchedCallback = fn;
    };
    TimeInputComponent.prototype.setDisabledState = function (isDisabled) {
        this.disabled = isDisabled;
    };
    return TimeInputComponent;
}());
TimeInputComponent.decorators = [
    { type: Component, args: [{
                selector: 'time-input',
                template: "<div>\n    <div class=\"form-group\" [ngClass]=\"{'has-error': Validations.isControlValid(form, propertyName)}\">\n        <label *ngIf=\"!fromTable && propertyMeta.label\" [class]=\"'control-label ' + propertyMeta.css.label\">\n            {{propertyMeta.label}}\n        </label>\n        <div [class]=\"fromTable ? '' : propertyMeta.css.input\">\n\n            <timepicker [showMeridian]=\"false\" [(ngModel)]=\"time\"></timepicker>\n\n        </div>\n\n        <validator-messages\n            [propertyName]=\"propertyName\"\n            [form]=\"form\"\n            [model]=\"model\"\n            [mode]=\"mode\">\n        </validator-messages>\n    </div>\n</div>",
                styles: [".control-label {\n        padding-top: 16px;\n    }"],
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: TimeInputComponent,
                        multi: true
                    }]
            },] },
];
TimeInputComponent.ctorParameters = function () { return []; };
TimeInputComponent.propDecorators = {
    "model": [{ type: Input },],
    "mode": [{ type: Input },],
    "form": [{ type: Input },],
    "propertyName": [{ type: Input },],
    "fromTable": [{ type: Input },],
};
var ValidatorMessagesComponent = /** @class */ (function () {
    function ValidatorMessagesComponent(formGenerator) {
        this.formGenerator = formGenerator;
        this.EntryTypes = EntryTypes;
        this.Validations = Validations;
    }
    ValidatorMessagesComponent.prototype.ngOnChanges = function (changes) {
        if (this.mode && this.propertyName)
            this.propertyMeta = this.model.getEntry(this.mode, this.propertyName);
    };
    ValidatorMessagesComponent.prototype.ngOnInit = function () {
    };
    return ValidatorMessagesComponent;
}());
ValidatorMessagesComponent.decorators = [
    { type: Component, args: [{
                selector: 'validator-messages',
                template: "\n<div *ngIf=\"Validations.isControlValid(form, propertyName)\"\n    [class]=\"propertyMeta.css.input\">\n    <div class=\"alert alert-danger\">\n        <div *ngFor=\"let msg of propertyMeta.validatorsMsgs | keys\">\n            <div *ngIf=\"form.controls[propertyName].errors[msg.key]\">\n                {{ msg.value }}\n            </div>\n        </div>\n    </div>\n</div>\n",
            },] },
];
ValidatorMessagesComponent.ctorParameters = function () { return [
    { type: FormGeneratorService, },
]; };
ValidatorMessagesComponent.propDecorators = {
    "model": [{ type: Input },],
    "mode": [{ type: Input },],
    "form": [{ type: Input },],
    "propertyName": [{ type: Input },],
};
var OneColumnLayout = /** @class */ (function () {
    function OneColumnLayout() {
        this.columns = [{
                name: 'center',
                cssClass: 'col-xs-12'
            }];
    }
    return OneColumnLayout;
}());
var TwoColumnLayout = /** @class */ (function () {
    function TwoColumnLayout() {
        this.columns = [{
                name: 'left',
                cssClass: 'col-lg-6 col-md-12'
            }, {
                name: 'right',
                cssClass: 'col-lg-6 col-md-12'
            }, {
                name: 'center',
                cssClass: 'col-xs-12'
            }];
    }
    return TwoColumnLayout;
}());
var ThreeColumnLayout = /** @class */ (function () {
    function ThreeColumnLayout() {
        this.columns = [{
                name: 'left',
                cssClass: 'col-lg-6 col-md-12'
            }, {
                name: 'right',
                cssClass: 'col-lg-6 col-md-12'
            }, {
                name: 'center',
                cssClass: 'col-xs-12'
            }, {
                name: 'normal',
                cssClass: 'col-lg-4 col-md-12'
            }];
    }
    return ThreeColumnLayout;
}());
var FormParams = /** @class */ (function () {
    function FormParams() {
    }
    return FormParams;
}());
var FormOptions = /** @class */ (function () {
    function FormOptions() {
    }
    return FormOptions;
}());
function Form(formParams) {
    return function (target) {
        if (!formParams && Object.keys(formParams || {}).length == 0) {
            throw new Error("\n                Must define at least one mode for @Form on model:\n                " + target.prototype.constructor.name + "\n            ");
        }
        var layoutInstance = {};
        Object.keys(formParams).forEach(function (key) {
            var formOptions = formParams[key];
            layoutInstance[key] = (formOptions && formOptions.layout) ?
                new formOptions.layout.prototype.constructor() :
                new OneColumnLayout();
        });
        Reflect.defineMetadata('__formParams__', formParams, target.prototype);
        target.prototype.getFormOptions = function (mode) {
            return Reflect.getMetadata('__formParams__', this)[mode];
        };
        Reflect.defineMetadata('__layout__', layoutInstance, target.prototype);
        target.prototype.getLayout = function (mode) {
            if (!mode) {
                throw Error("@Form.getLayout: no mode provided");
            }
            return Reflect.getMetadata('__layout__', this)[mode];
        };
        target.prototype.getEntry = function (mode, key) {
            if (!mode) {
                throw Error("@Form.getEntry: no mode provided");
            }
            var ownEntry = Reflect.getOwnMetadata("__entry__", this, key);
            if (!ownEntry) {
                var value = Reflect.getMetadata("__entry__", this, key);
                Reflect.defineMetadata("__entry__", cloneDeep(value), this, key);
            }
            var entr = Reflect.getOwnMetadata("__entry__", this, key);
            if (!entr) {
                throw Error("@Form.getEntry: no entry " + key);
            }
            return entr[mode];
        };
        target.prototype.getEntries = function (mode) {
            var _this = this;
            if (!mode) {
                throw Error("@Form.getEntries: no mode provided");
            }
            var entries = [];
            this.getProperties(mode).forEach(function (property) {
                entries.push(_this.getEntry(mode, property));
            });
            return entries;
        };
        target.prototype.getProperties = function (mode) {
            var _this = this;
            if (!mode) {
                throw Error("@Form.getProperties: no mode provided");
            }
            return Reflect.getMetadata('__properties__', this)
                .filter(function (property) { return !!_this.getEntry(mode, property); });
        };
        target.prototype.getPropertiesByLayout = function (mode, layout) {
            var _this = this;
            if (!mode) {
                throw Error("@Form.getPropertiesByLayout: no mode provided");
            }
            return this.getProperties(mode).filter(function (key) {
                return _this.getEntry(mode, key).layout === layout;
            });
        };
        target.prototype.registerEntryDynamicProperty = function (modes, propertyName, entryOptionName, entryOptionValue) {
            var _this = this;
            modes.forEach(function (mode) {
                _this.getEntry(mode, propertyName)[entryOptionName] = entryOptionValue;
            });
        };
        target.prototype.registerEntriesDynamicProperties = function (modes, entries) {
            var _this = this;
            modes.forEach(function (mode) {
                Object.keys(entries).forEach(function (property) {
                    Object.keys(entries[property]).forEach(function (key) {
                        _this.getEntry(mode, property)[key] = entries[property][key];
                    });
                });
            });
        };
        target.prototype.registerEntriesDynamicProperty = function (modes, propertyName, entryOptions) {
            var _this = this;
            Object.keys(entryOptions).forEach(function (key) {
                modes.forEach(function (mode) {
                    _this.getEntry(mode, propertyName)[key] = entryOptions[key];
                });
            });
        };
        target.prototype.registerFormOnChanges = function (modes, onChanges) {
            var _this = this;
            modes.forEach(function (mode) {
                _this.getFormOptions(mode).onChanges = onChanges;
            });
        };
    };
}
var KeysPipe = /** @class */ (function () {
    function KeysPipe() {
    }
    KeysPipe.prototype.transform = function (value, args) {
        var keys = [];
        for (var key in value) {
            keys.push({ key: key, value: value[key] });
        }
        return keys;
    };
    return KeysPipe;
}());
KeysPipe.decorators = [
    { type: Pipe, args: [{ name: 'keys' },] },
];
var StoreMetadata = /** @class */ (function () {
    function StoreMetadata() {
    }
    StoreMetadata.getInstance = function () {
        if (!this._instance) {
            this._instance = new StoreMetadata();
        }
        return this._instance;
    };
    return StoreMetadata;
}());
StoreMetadata._instance = null;
var ResourceParams = /** @class */ (function () {
    function ResourceParams() {
    }
    return ResourceParams;
}());
var ResourceHandle = /** @class */ (function () {
    function ResourceHandle() {
    }
    return ResourceHandle;
}());
var ResourceMethods = /** @class */ (function () {
    function ResourceMethods() {
    }
    return ResourceMethods;
}());
var DefaultResourceMethods = /** @class */ (function (_super) {
    __extends(DefaultResourceMethods, _super);
    function DefaultResourceMethods() {
        var _this = _super.apply(this, __spread(arguments)) || this;
        _this.methods = {
            save: function (url, http, form, params, options) {
                if (params === void 0) { params = []; }
                if (options === void 0) { options = {}; }
                var body = buildQueryParams(form, params);
                return http.post(url, body, options);
            },
            update: function (url, http, form, params, options) {
                if (params === void 0) { params = []; }
                if (options === void 0) { options = {}; }
                var body = buildQueryParams(form, params);
                return http.patch(url, body, options);
            },
            find: function (url, http, form, params, options) {
                if (params === void 0) { params = []; }
                if (options === void 0) { options = {}; }
                var body = '?params=' + JSON.stringify(buildQueryParams(form, params));
                return http.get(url + body, options);
            },
            get: function (url, http, id, options) {
                if (options === void 0) { options = {}; }
                return http.get(url + "/" + id, options);
            },
            delete: function (url, http, id, options) {
                if (options === void 0) { options = {}; }
                return http.get(url + "/" + id, options);
            },
        };
        return _this;
    }
    return DefaultResourceMethods;
}(ResourceHandle));
var ResourceMethod = {
    GET: 'get',
    POST: 'post',
    PUT: 'put',
    PATCH: 'patch',
    DELETE: 'delete',
};
function Resource(resourceParams) {
    return function (target) {
        if (!resourceParams && Object.keys(resourceParams || {}).length === 0) {
            throw new Error("\n                Must define at least one mode for @Resource on model:\n                " + target.prototype.constructor.name + "\n            ");
        }
        target.prototype.getResource = function (mode, method) {
            var _this = this;
            if (!mode) {
                throw Error("@Resource.getResource: no mode provided");
            }
            var call = function () {
                var params = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    params[_i] = arguments[_i];
                }
                var _a = __read(params, 2), http = _a[0], formGroup = _a[1];
                if (method === 'post')
                    formGroup = params[2];
                var actualMethod = Reflect.getMetadata("__resourceParams__", _this).modes[mode][method];
                if (formGroup instanceof FormGroup && !formGroup.valid) {
                    validateAllFormFields(formGroup);
                    return Observable.throw(new Error('Validation errors'));
                }
                else if (resourceParams.modes[mode].cacheMethods
                    && resourceParams.modes[mode].cacheMethods.includes(method)) {
                    if (!_this.getCache(mode, method)) {
                        Reflect.defineMetadata("__resourceCache__" + mode + "__" + method, actualMethod.apply(void 0, __spread([resourceParams.modes[mode].url], params)).shareReplay(1), _this);
                    }
                    return _this.getCache(mode, method);
                }
                else {
                    return actualMethod.apply(void 0, __spread([resourceParams.modes[mode].url], params));
                }
            };
            return {
                call: call
            };
        };
        target.prototype.getCache = function (mode, method) {
            return Reflect.getOwnMetadata("__resourceCache__" + mode + "__" + method, this);
        };
        target.prototype.invalidateCache = function (mode, method) {
            Reflect.deleteMetadata("__resourceCache__" + mode + "__" + method, this);
        };
        var actualResource = { modes: {} };
        Object.keys(resourceParams.modes).forEach(function (mode) {
            actualResource.modes[mode] = {};
            var methods = merge({}, new DefaultResourceMethods().methods, resourceParams.modes[mode].methods);
            Object.keys(methods).forEach(function (method) {
                actualResource.modes[mode][method] = methods[method];
            });
        });
        Reflect.defineMetadata("__resourceParams__", actualResource, target.prototype);
        var storeMeta = StoreMetadata.getInstance();
        if (resourceParams.store && resourceParams.store.reducer) {
            var reducers = Reflect.getMetadata('__reducers__', storeMeta) || {};
            reducers[resourceParams.store.namespace] = resourceParams.store.reducer;
            Reflect.defineMetadata('__reducers__', reducers, storeMeta);
        }
        if (resourceParams.store && resourceParams.store.epics) {
            var epics = Reflect.getMetadata('__epics__', storeMeta) || [];
            epics.push.apply(epics, __spread(resourceParams.store.epics));
            Reflect.defineMetadata('__epics__', epics, storeMeta);
        }
    };
}
var validateAllFormFields = function (formGroup) {
    Object.keys(formGroup.controls).forEach(function (field) {
        var control = formGroup.get(field);
        if (control instanceof FormControl) {
            control.markAsTouched({ onlySelf: true });
        }
        else if (control instanceof FormGroup) {
            validateAllFormFields(control);
        }
        else if (control instanceof FormArray) {
            control.controls.forEach(function (control) {
                validateAllFormFields(control);
            });
        }
    });
};
var buildQueryParams = function (form, params) {
    var body = Object.assign({}, pickBy(form.value, identity), pickBy(params, identity));
    return body;
};
var StoreService = /** @class */ (function () {
    function StoreService() {
        this._storeMeta = StoreMetadata.getInstance();
        if (!StoreService.INSTANCE) {
            StoreService.INSTANCE = this;
        }
        return StoreService.INSTANCE;
    }
    StoreService.prototype.createStore = function () {
        var reducers = Reflect.getMetadata('__reducers__', this._storeMeta);
        var epics = Reflect.getMetadata('__epics__', this._storeMeta);
        var rootEpic = combineEpics.apply(void 0, __spread(epics));
        var epicMiddleware = createEpicMiddleware(rootEpic);
        this._store = createStore(combineReducers(reducers), {}, composeWithDevTools(applyMiddleware(epicMiddleware)));
        this.currentState = this._store.getState();
    };
    StoreService.prototype.getState = function (select) {
        var _this = this;
        var currentValue = select(this._store.getState());
        return Observable$1.create(function (observer) {
            observer.next(currentValue);
            var unsubscribe = _this._store.subscribe(function () {
                var newValue = select(_this._store.getState());
                if (!isEqual(currentValue, newValue)) {
                    currentValue = newValue;
                    observer.next(newValue);
                }
            });
            return unsubscribe;
        });
    };
    StoreService.prototype.dispatch = function (action) {
        this._store.dispatch(action);
    };
    return StoreService;
}());
StoreService.INSTANCE = null;
StoreService.decorators = [
    { type: Injectable },
];
StoreService.ctorParameters = function () { return []; };
var moment$1 = moment_;
var DateInputComponent = /** @class */ (function () {
    function DateInputComponent(formGenerator) {
        this.formGenerator = formGenerator;
        this.EntryTypes = EntryTypes;
        this.Validations = Validations;
        this.blur = new EventEmitter();
        this.focus = new EventEmitter();
        this.onTouchedCallback = function () { };
        this.onChangeCallback = function () { };
    }
    Object.defineProperty(DateInputComponent.prototype, "date", {
        get: function () {
            return this.dateModel;
        },
        set: function (value) {
            this.dateModel = value;
            this.onChangeCallback((value && value.formatted)
                ? moment$1(value.jsdate).format(this.propertyMeta.format)
                : value);
        },
        enumerable: true,
        configurable: true
    });
    DateInputComponent.prototype.onBlur = function () {
        this.blur.emit();
    };
    DateInputComponent.prototype.onFocus = function () {
        this.focus.emit();
    };
    DateInputComponent.prototype.ngOnInit = function () {
        this.propertyMeta = this.model.getEntry(this.mode, this.propertyName);
        this.myOptions = {
            dateFormat: this.propertyMeta.formatDisplay
        };
        this.setFrLocale();
        if (this.autofocus) {
            this.dp.nativeElement.focus();
        }
    };
    DateInputComponent.prototype.ngOnChanges = function (changes) {
    };
    DateInputComponent.prototype.writeValue = function (obj) {
        if (!obj) {
            this.date = '';
            return;
        }
        var value = moment$1(obj, this.propertyMeta.format);
        this.date = { date: {
                year: value.year(),
                month: value.month() + 1,
                day: value.date()
            } };
    };
    DateInputComponent.prototype.registerOnChange = function (fn) {
        this.onChangeCallback = fn;
    };
    DateInputComponent.prototype.registerOnTouched = function (fn) {
        this.onTouchedCallback = fn;
    };
    DateInputComponent.prototype.setDisabledState = function (isDisabled) {
        this.disabled = isDisabled;
    };
    DateInputComponent.prototype.setFrLocale = function () {
        this.myOptions.dayLabels = { su: 'Dim', mo: 'Lun', tu: 'Mar', we: 'Mer', th: 'Jeu', fr: 'Ven', sa: 'Sam' };
        this.myOptions.monthLabels = { 1: 'Jan', 2: 'Fév', 3: 'Mar', 4: 'Avr', 5: 'Mai', 6: 'Juin',
            7: 'Juil', 8: 'Aoû', 9: 'Sep', 10: 'Oct', 11: 'Nov', 12: 'Déc' };
        this.myOptions.dateFormat = 'dd/mm/yyyy';
        this.myOptions.todayBtnTxt = 'Aujourd\'hui';
        this.myOptions.firstDayOfWeek = 'mo';
        this.myOptions.sunHighlight = true;
    };
    return DateInputComponent;
}());
DateInputComponent.decorators = [
    { type: Component, args: [{
                selector: 'date-input',
                template: "<div>\n    <div class=\"form-group\" [ngClass]=\"{'has-error': Validations.isControlValid(form, propertyName)}\">\n        <label *ngIf=\"!fromTable && propertyMeta.label\" [class]=\"'control-label ' + propertyMeta.css.label\">\n            {{propertyMeta.label}}\n        </label>\n        <div [class]=\"fromTable ? '' : propertyMeta.css.input\">\n            <div class=\"input-group\">\n\n                <input class=\"form-control\"\n                    ngx-mydatepicker\n                    [placeholder]=\"propertyMeta.placeholder ? propertyMeta.placeholder : ''\"\n                    [name]=\"propertyName\"\n                    [(ngModel)]=\"date\"\n                    [options]=\"myOptions\"\n                    #dp\n                    #datepicker=\"ngx-mydatepicker\"\n                    (blur)=\"onBlur()\"\n                    (focus)=\"onFocus()\"/> <!--=\"ngx-mydatepicker\"-->\n                <span class=\"input-group-btn\">\n                    <button type=\"button\" class=\"btn btn-default\" (click)=\"datepicker.clearDate()\">\n                        <i class=\"fa fa-remove\"></i>\n                    </button>\n                </span>\n                <span class=\"input-group-btn\">\n                    <button type=\"button\" class=\"btn btn-default\" (click)=\"datepicker.toggleCalendar()\">\n                        <i class=\"fa fa-calendar\"></i>\n                    </button>\n                </span>\n            </div>\n        </div>\n\n        <validator-messages\n            [propertyName]=\"propertyName\"\n            [form]=\"form\"\n            [model]=\"model\"\n            [mode]=\"mode\">\n        </validator-messages>\n    </div>\n</div>",
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: DateInputComponent,
                        multi: true
                    }]
            },] },
];
DateInputComponent.ctorParameters = function () { return [
    { type: FormGeneratorService, },
]; };
DateInputComponent.propDecorators = {
    "model": [{ type: Input },],
    "mode": [{ type: Input },],
    "form": [{ type: Input },],
    "propertyName": [{ type: Input },],
    "fromTable": [{ type: Input },],
    "autofocus": [{ type: Input },],
    "blur": [{ type: Output },],
    "focus": [{ type: Output },],
    "dp": [{ type: ViewChild, args: ['dp',] },],
};
var StaticInputComponent = /** @class */ (function () {
    function StaticInputComponent(formGenerator) {
        this.formGenerator = formGenerator;
        this.EntryTypes = EntryTypes;
        this.Validations = Validations;
    }
    StaticInputComponent.prototype.ngOnInit = function () {
        this.propertyMeta = this.model.getEntry(this.mode, this.propertyName);
    };
    StaticInputComponent.prototype.callOnClick = function () {
        if (typeof this.propertyMeta.onClick === 'function')
            this.propertyMeta.onClick();
    };
    return StaticInputComponent;
}());
StaticInputComponent.decorators = [
    { type: Component, args: [{
                selector: 'static-input',
                template: "\n<div [formGroup]=\"form\" >\n    <div class=\"form-group\" [ngClass]=\"{'has-error': Validations.isControlValid(form, propertyName)}\">\n        <label *ngIf=\"!fromTable && propertyMeta.label\" [class]=\"'control-label ' + propertyMeta.css.label\">\n            {{propertyMeta.label}}\n        </label>\n        <span [class]=\"fromTable ? '' : propertyMeta.css.input\">\n            <div [ngClass]=\"{'input-group': propertyMeta.css.btn}\">\n                <p class=\"form-control-static\">\n                    {{\n                        propertyMeta.transform ?\n                            propertyMeta.transform(form.controls[propertyName].value, model) :\n                            form.controls[propertyName].value\n                    }}\n                </p>\n\n                <span *ngIf=\"propertyMeta.css.btn\" class=\"input-group-btn\">\n                    <button type=\"button\" class=\"btn btn-default\" (click)=\"callOnClick()\">\n                        <i [class]=\"propertyMeta.css.btn\"></i>\n                    </button>\n                </span>\n            </div>\n        </span>\n\n        <validator-messages\n            [propertyName]=\"propertyName\"\n            [form]=\"form\"\n            [model]=\"model\"\n            [mode]=\"mode\">\n        </validator-messages>\n    </div>\n</div>",
            },] },
];
StaticInputComponent.ctorParameters = function () { return [
    { type: FormGeneratorService, },
]; };
StaticInputComponent.propDecorators = {
    "model": [{ type: Input },],
    "mode": [{ type: Input },],
    "form": [{ type: Input },],
    "propertyName": [{ type: Input },],
    "fromTable": [{ type: Input },],
};
var NgxResourceToolkit = /** @class */ (function () {
    function NgxResourceToolkit() {
    }
    return NgxResourceToolkit;
}());
NgxResourceToolkit.decorators = [
    { type: NgModule, args: [{
                imports: [
                    HttpClientModule,
                    CommonModule,
                    FormsModule,
                    ReactiveFormsModule,
                    NgxDatatableModule,
                    NgxMyDatePickerModule.forRoot(),
                    ColorPickerModule,
                    TimepickerModule.forRoot(),
                ],
                providers: [
                    FormGeneratorService,
                    StoreService,
                ],
                declarations: [
                    KeysPipe,
                    ValidatorMessagesComponent,
                    AutoFormComponent,
                    FormInputComponent,
                    BasicInputComponent,
                    TextareaInputComponent,
                    SelectInputComponent,
                    RadioInputComponent,
                    CheckboxInputComponent,
                    ColorInputComponent,
                    DateInputComponent,
                    TimeInputComponent,
                    StaticInputComponent,
                    AutoTableComponent,
                    AutoCardsComponent,
                ],
                exports: [
                    AutoFormComponent,
                    AutoTableComponent,
                    AutoCardsComponent,
                ],
                schemas: [CUSTOM_ELEMENTS_SCHEMA]
            },] },
];

export { BaseModel, AutoFormComponent, TableMode, TableButton, AutoTableComponent, CardMode, CardBox, AutoCardsComponent, FormInputComponent, BasicInputComponent, SelectInputComponent, RadioInputComponent, CheckboxInputComponent, TextareaInputComponent, ColorFormat, ColorInputComponent, TimeFormat, TimeInputComponent, Validations, ValidatorMessagesComponent, Entry, EntryTypes, Option, EntryParams, EntryOptions, BasicEntryOptions, DateEntryOptions, ChoicesEntryOptions, CollectionEntry, CardEntryOptions, TableEntryOptions, Form, FormParams, FormOptions, OneColumnLayout, TwoColumnLayout, ThreeColumnLayout, KeysPipe, FormGeneratorService, StoreMetadata, Resource, ResourceParams, ResourceHandle, ResourceMethods, DefaultResourceMethods, ResourceMethod, validateAllFormFields, buildQueryParams, StoreService, NgxResourceToolkit, DateInputComponent as ɵa, StaticInputComponent as ɵb };
//# sourceMappingURL=ngx-resource-toolkit-core.js.map



//////////////////
// WEBPACK FOOTER
// /home/debian/git/lea/ngx-resource-toolkit/packages/core/dist/esm5/ngx-resource-toolkit-core.js
// module id = ../../../../../../ngx-resource-toolkit/packages/core/dist/esm5/ngx-resource-toolkit-core.js
// module chunks = main